// Canonieke locatietypes — spiegelt backend/location_types.py.
// "truckwash" is de opslagwaarde van een wasstraat; "wasstraat" is een legacy-alias.
export const WASH_TYPES = ['truckwash', 'wasstraat'];

export const LOCATIE_TYPES = [
  { value: 'truckwash', label: 'Wasstraat' },
  { value: 'hoofdkantoor', label: 'Hoofdkantoor' },
  { value: 'techniek', label: 'Techniek & Beheer' },
  { value: 'truckshop', label: 'Truckshop' },
  { value: 'truckstop', label: 'Truckstop' },
];

const equivalents = (value) => (WASH_TYPES.includes(value) ? WASH_TYPES : [value]);

// Aantal echte locaties van dit type, met correct enkelvoud/meervoud.
export const formatLocatieCount = (locaties, value) => {
  const n = (locaties || []).filter((l) => equivalents(value).includes(l.type)).length;
  return `${n} ${n === 1 ? 'locatie' : 'locaties'}`;
};

// 6.23: ISO-correcte maand van een weeknummer (donderdag van de ISO-week).
// De oude berekening liep een week voor wanneer 1 januari op vr/za/zo valt.
export const maandVanIsoWeek = (jaar, week) => {
  const vierdeJan = new Date(Date.UTC(Number(jaar), 0, 4));
  const dagVanWeek = vierdeJan.getUTCDay() || 7;          // ma=1 … zo=7
  const weekEenMaandag = new Date(vierdeJan);
  weekEenMaandag.setUTCDate(vierdeJan.getUTCDate() - (dagVanWeek - 1));
  const donderdag = new Date(weekEenMaandag);
  donderdag.setUTCDate(weekEenMaandag.getUTCDate() + (Number(week) - 1) * 7 + 3);
  return donderdag.getUTCMonth() + 1;
};

// 6.21: de wasstraat-checkbox dekt BEIDE opslagwaarden. Anders bleef het legacy
// 'wasstraat' staan na het uitvinken en bleef de backend wasstraten matchen.
export const typeAangevinkt = (types, waarde) => (
  WASH_TYPES.includes(waarde)
    ? (types || []).some(t => WASH_TYPES.includes(t))
    : (types || []).includes(waarde)
);

export const typeToggle = (types, waarde, aan) => {
  const huidig = types || [];
  const weg = WASH_TYPES.includes(waarde) ? WASH_TYPES : [waarde];
  const zonder = huidig.filter(t => !weg.includes(t));
  return aan ? [...zonder, waarde] : zonder;
};

// E11: ISO-week → maandag..zondag. De oude berekening ging uit van jan-4 minus
// getDay() en liep een week mis wanneer 4 januari op zondag valt (2026).
export const isoWeekMaandag = (jaar, week) => {
  const vierdeJan = new Date(Date.UTC(Number(jaar), 0, 4));
  const dagVanWeek = vierdeJan.getUTCDay() || 7;
  const weekEen = new Date(vierdeJan);
  weekEen.setUTCDate(vierdeJan.getUTCDate() - (dagVanWeek - 1));
  const maandag = new Date(weekEen);
  maandag.setUTCDate(weekEen.getUTCDate() + (Number(week) - 1) * 7);
  return maandag;
};

export const isoWeekRange = (jaar, week) => {
  const start = isoWeekMaandag(jaar, week);
  const eind = new Date(start);
  eind.setUTCDate(start.getUTCDate() + 6);
  const fmt = (d) => d.toLocaleDateString('nl-NL', {
    day: '2-digit', month: 'short', timeZone: 'UTC',
  });
  return `${fmt(start)} \u2013 ${fmt(eind)}`;
};

// Aantal ISO-weken in een jaar: 52, of 53 als 1 januari of 31 december donderdag is.
export const isoWekenInJaar = (jaar) => {
  const donderdag = (d) => d.getUTCDay() === 4;
  return (donderdag(new Date(Date.UTC(Number(jaar), 0, 1)))
    || donderdag(new Date(Date.UTC(Number(jaar), 11, 31)))) ? 53 : 52;
};

export const isoWeekJaar = (datum) => {
  const d = new Date(Date.UTC(datum.getFullYear(), datum.getMonth(), datum.getDate()));
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));   // donderdag van deze week
  return d.getUTCFullYear();
};
